










































































import Vue from 'vue';
import Component from 'vue-class-component';
import isEqual from 'lodash.isequal';
import isUndefined from 'lodash.isundefined';
import isNull from 'lodash.isnull';
import genericapi  from '../assets/ts/genericAPIAxios';
// Vue.prototype.$genericapi = genericapiinstance;

@Component
export default class EBiennialFixSearch extends Vue {
  private licenseSpeAppId: string = '';
  private BusinessName: string = '';
  private errors = [];
  private label = [];
  private configurationName: string = 'PAYMENT';
  private imageFolderPath: string = '';
  private filingResponse: any = {};
  // private genericInstance = this.$genericapi;

  private created() {
    console.log('Inside created of first page');
    //this.$store.commit('ebiennial/setEBiennialData', null);
    if (this.empty(this.label) || this.label.length === 0) {
     this.fetchLabels().then((labelResponse: any) => {
       console.log(labelResponse);
       this.label = labelResponse;
        // console.log('first pragraph:'+this.label.EBIENNIAL_HOME_PARAGRAPH_1);
      });
    }
    console.log('imageFolderPath:' + this.imageFolderPath);
  }
  private getLabelValue(keyPassed: string) {
    for (let i = 0; i < this.label.length; i++) {
      for (const key in this.label[i] ) {
        if (key === keyPassed) {
          console.log('Matched if');
          return this.label[i][key];
        }

      }
    }
    // console.log('label value:'+this.label[keyPassed]);
    // return this.label[keyPassed];
  }
  private getImageURL(columnname: string) {
     const images = require.context('@/assets/images/', true, /\.jpg$/);
     return images('./' + this.getLabelValue(columnname));
    // return this.getLabelValue(columnname);
  }
  private fetchLabels() {
     // return this.$http.get('Ebiennial/GetConfigurationData', {
      //  return genericapi.get('Ebiennial/GetConfigurationData', {
        return genericapi.get('Generic/GetConfigurationData', {
          params: {
          group: 'SECTION',
          application: 'EBIENNIAL',
      },

    }).then((response: any) => {
      console.log(response);

      // console.log('key value:'+response.data.values[response.data.map(function(o) { return o.key; }).indexOf('EBIENNIAL_HOME_PARAGRAPH_1')]);
      return response.data;
    }).catch((error: any) => {
      console.log(error);
    });
  }
  private search(): void {
    const store = this.$store;
    const http = this.$http;
    this.errors.length = 0;
    if (this.empty(this.licenseSpeAppId)) {
      console.log('DOS ID missing');
      this.errors.push('License spec app ID missing.');
    }
    if (this.errors.length) {
   console.log('Missing values');
   return;
  }

// http.post('ebiennial/getBbiennial', {
    http.get('EbiennialFix/GetEBiennialTransactionData', {
      params: {
          licenseSpecAppId: this.licenseSpeAppId,
        },
    }).then((response: any) => {
      console.log(response.data);
      //response = response.data.eBiennialSearchResult;
      //console.log(response);
      store.commit("ebiennial/setEbiennialTransactionData", response.data);
      this.$router.push({ name: 'fix' });
      // console.log(response.filingData);
      //console.log('isSuccess:' + response.requestStatus);
      // store.commit('ebiennial/setEBiennialData', response.filingData);
    //   if (response.requestStatus === 'Success') {
    //     if(!this.empty(response.errorMessage)){
    //       let flag=this.getLabelValue('EBIENNIAL_BYPASS_NOT_ELIGIBLE_FILING');

    //       if(flag.toLowerCase()=="true"){
    //         this.populateFilingInfo(response);
    //         console.log('after populating filing search result in the method');
    //         console.log(this.filingResponse);
    //         store.commit('ebiennial/setEBiennialData', this.filingResponse);
    //         this.$router.push({ name: 'verification' });
    //       }
    //       else{
    //         console.log(response.errorMessage);
    //         if(response.errorMessage==this.getLabelValue('EBIENNIAL_ERROR_FILING_WINDOW_DATE')){
    //           console.log('into if');
    //           this.errors.push(this.getLabelValue('EBIENNIAL_ERROR_FILING_WINDOW_DATE_NEW_MESSAGE'));
    //         }else{
    //           this.errors.push(response.errorMessage);
    //         }

    //         console.log('after populating filing search result in the method');
    //         console.log(this.filingResponse);
    //       }

    //     }else{
    //       this.populateFilingInfo(response);
    //       console.log('after populating filing search result in the method');
    //       console.log(this.filingResponse);
    //       store.commit('ebiennial/setEBiennialData', this.filingResponse);
    //       this.$router.push({ name: 'verification' });
    //     }
    //   } else {
    //       console.log(response.errorMessage);
    //       if(response.errorMessage==this.getLabelValue('EBIENNIAL_ERROR_FILING_WINDOW_DATE')){
    //         console.log('into if');
    //         this.errors.push(this.getLabelValue('EBIENNIAL_ERROR_FILING_WINDOW_DATE_NEW_MESSAGE'));
    //       }else{
    //         this.errors.push(response.errorMessage);
    //       }


    //   }

    }).catch((error: any) => {
      // this.error = error
      console.log(error);
      this.errors.push(error);
    });
  }
    private reset(): void {
        this.errors.length = 0;
        this.licenseSpeAppId = '';
        //this.BusinessName = '';
    return;
   }
    private empty(e) {
    switch (e) {
      case '':
      case '':
      case 0:
      case '0':
      case null:
      case false:
      case typeof this === 'undefined':
      case typeof this === undefined:
      return true;
      default:
        return false;
    }
  }
 }
